<div mat-dialog-content class="dialog-content">
  <h1 class="title">ALTERAR O STATUS DA NEGOCIAÇÃO</h1>
  <i class="fa-solid fa-times close-btn" (click)="close()"></i>
  <p class="sub-title mb-4">
    Escolha abaixo o novo status para sua negociação:
  </p>

  <div class="row negotiation-status-options mb-3">
    @for (option of statusOptions; track option.key) {
      <div class="column col-6">
        <div
          class="segment-card {{ option.class }}"
          [class.selected]="statusSelected === option.key"
          (click)="selectStatus(option.key)"
        >
          <div class="segment-card-content">
            <div class="segment-card-icon">
              <i class="fa-solid" [class]="option.icon"></i>
            </div>
            <div class="segment-card-label">{{ option.label }}</div>
            <div class="segment-card-check">
              <span class="material-icons check-selected mx-0">check_circles</span>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  <button
    type="button"
    class="btn btn-primary btn-rounded btn-block"
    [disabled]="!statusSelected || loading"
    (click)="confirm()"
  >
    <span>ALTERAR STATUS</span>
  </button>

  <button type="button" class="btn btn-transparent btn-rounded btn-block" (click)="close()">
    <span>CANCELAR</span>
  </button>
</div>
